<template>
<div class="accountExtract ">
    <div class="status">
        <img src="../assets/fail.png" alt="" width="27%">
        <p>抱歉，支付失败</p>
    </div>
     <div class="info">
         <p class="title">
          失败原因：付款总额超过了您的这张银行卡的付款限额，无法付款
         </p>
     </div>
     <div class="wrap-btn-foot">
         <button  class="btn-md">返回重新支付</button>
     </div>
</div>
</template>

<script>
import { Checklist } from 'mint-ui';
import { Indicator } from 'mint-ui';
import { Toast } from 'mint-ui';
import {Get,Post} from '@/utils/http';
import { Cell } from 'mint-ui';
export default {
  name: 'Recharge',
  data () {
    return {
        value:'',
    }
  },
  computed: {
  
  },
  beforeMount(){

  },
   mounted() {
  
  },
   filters: {
  
  },
   methods: {
    
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.status{
    margin: 0.6rem auto 0.3rem;
    text-align: center;
}
.status p{
    margin-top:10px;
}
.info{
    margin:.2rem;
    text-align: center;
}
.deal_amount{
    margin:0.1rem;
    font-size: .35rem;
}
.wrap-btn-foot{
    margin: .7rem 0 0;
    padding: 0 .15rem;
}
.btn-md {
    -webkit-tap-highlight-color: rgba(255,255,255,0);
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    margin: 0;
    font-size: 100%;
    font-family: inherit;
    outline-offset: 0;
    outline-style: none;
    outline-width: 0;
    -webkit-font-smoothing: inherit;
    background-image: none;
    text-indent: 0;
    padding-left: 0;
    padding-right: 0;
    border: 0;
    background-color: #3b8aff;
    color: #fff;
    border: none;
    width: 100%;
    height: .44rem;
    line-height: .44rem;
    font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/views/Fail.vue